import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProgramacionMasivaService {
  private apiUrl = `${environment.apiUrl}/programacion-masiva`;

  constructor(private http: HttpClient) { }

  guardarCarga(data: any[]): Observable<any> {
    return this.http.post(`${this.apiUrl}/guardar-carga`, data);
  }
  
  getProgramacionParaManana(procesarHoy: boolean = false): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/programacion-diaria?procesarHoy=${procesarHoy}`);
  }
  
  updateProgramacion(id: number, data: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/programacion-diaria/${id}`, data);
  }

  // [CR-202609-0003] Envía solicitud para adelantar preventivo y generar ticket directo
  adelantarPreventivo(id: number, data: { fecha_visita: string; rut_tecnico1?: string; rut_tecnico2?: string }): Observable<any> {
    return this.http.post(`${this.apiUrl}/adelantar-preventivo/${id}`, data);
  }
  
  /**
   * Ejecuta el proceso manual.
   * @param fecha (Opcional) Fecha formato 'YYYY-MM-DD'. Si no se envía, el backend usará la fecha de mañana automáticamente.
   */
  ejecutarProcesoManual(fecha?: string): Observable<any> {
    // Si hay fecha, enviamos { fecha: "2026-01-18" }, si no, enviamos objeto vacío {}
    const body = fecha ? { fecha } : {};
    return this.http.post(`${this.apiUrl}/ejecutar-proceso`, body);
  }
 
  procesarProgramacion(procesarHoy: boolean): Observable<any> {    
    return this.http.post<any>(`${this.apiUrl}/ejecutar-proceso`, { procesarHoy });
  }

  getProgramacion(params: any): Observable<any> {
    let httpParams = new HttpParams();
    
    Object.keys(params).forEach(key => {
      const value = params[key];
      // Se eliminó el === '' para evitar enviar strings vacíos que confundan al backend
      if (value !== null && value !== undefined && value !== '') {
        if (value instanceof Date) {
           // Formato ISO simple YYYY-MM-DD
           httpParams = httpParams.set(key, value.toISOString().split('T')[0]);
        } else {
           httpParams = httpParams.set(key, value);
        }
      }
    });

    // Como ahora la exportación a Excel se arma en el componente (Frontend)
    // Siempre pedimos un JSON estándar, eliminamos el responseType: 'blob'.
    return this.http.get<any>(`${this.apiUrl}/reporte-historico`, { params: httpParams });
  }
}